import React from 'react';
import { connect } from 'react-redux';
import { closeAllModals } from '../actions/modalActions';

const Modal = connect()(
  ({ children, open = false, header = '', className = '', closeBtn = true, onClose, dispatch }) => {
    const closeModal = function () {
      onClose && onClose();
      dispatch(closeAllModals());
    };
    return open ? (
      <div className="lightbox-screen">
        <div className={'lightbox ' + className}>
          <div className="body">
            {closeBtn ? <i onClick={closeModal} className="close" /> : null}
            {<h3 className="alt-font center">{header}</h3>}
            {children}
          </div>
        </div>
      </div>
    ) : null;
  }
);

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js